import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AgentTabDesc extends Component {

    constructor(props) {
        super(props);
        this.openAgentAddModal=this.openAgentAddModal.bind(this);
    }

    openAgentAddModal(){
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show":true,
                "page":this.props.modalpage,
                "size":this.props.size
            }
        });
    }


    render() {
        const { t } = this.props;
        return (
            <div className="settings-header">
                <div className="row align-items-center">
                    <div className="col-md-8"><h5>{this.props.title}</h5><p>{this.props.description}</p></div>
                    {typeof this.props.button_title !== "undefined" &&
                    <div className="col-md-4 text-md-right">
                        <button className="btn btn-primary" onClick={this.openAgentAddModal.bind(this)}>
                            <i className="bx bx-plus"></i>&nbsp;{this.props.button_title}
                        </button>
                    </div>
                    }

                </div>
            </div>

        );
    }
}

export default withTranslation()(AgentTabDesc);
